import type { Styles } from 'common/types';

export const styles: Styles = {
  container: {
    p: 2,
    borderRadius: 2,
    borderStyle: 'dashed',
    width: 320,
    height: 370,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  stack: {
    flex: 1,
    overflow: 'hidden',
  },
  fileUploaderWrapper: {
    flexShrink: 0,
  },
  textField: {
    '& .MuiInputBase-inputMultiline': {
      height: '50px !important',
      overflow: 'auto !important',
      resize: 'none !important',
    },
  },
  actions: {
    display: 'flex',
    gap: 1,
  },
};
